export default __webpack_public_path__ + "static/media/backspace-arrow-disabled.b692c8f2.svg";